<template>
  <h1 class="heading" v-bind:class="{ 'heading--divider': hasDivider }">
    <span>{{ title }}</span>
  </h1>
</template>

<script>
export default {
  name: "Heading",
  props: ["title", "hasDivider"]
};
</script>

